module.exports = __webpack_public_path__ + "static/media/avatarDemo.0e3eaaf4.jpg";